/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profilency_dashboard': {
    width: 17,
    height: 19,
    viewBox: '0 0 17 19',
    data: '<path pid="0" d="M.078 10.601V.477h7.745v10.124H.078zm6.745-1V1.477H1.078v8.124h5.745zM8.95 6.745V.477h7.745v6.268H8.95zm6.745-1V1.477H9.95v4.268h5.745zM8.95 18.476V8.352h7.745v10.124H8.95zm6.745-1V9.352H9.95v8.124h5.745zm-15.617 1v-6.268h7.745v6.268H.078zm6.745-1v-4.268H1.078v4.268h5.745z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/profilency_dashboard.js